import { AllCommunityModule, ModuleRegistry, themeQuartz, TooltipModule } from 'ag-grid-community'; 
import { createGrid } from 'ag-grid-community';

// ! rename the function to align with the widget name
export const collectionSonataTable = async () => {
    const el = document.querySelector('.curious-collection-sonata-table');
    if (!el) return;

    // ------------------------------------------------------------
    const loadingStates = document.querySelectorAll('.table-container');
    ModuleRegistry.registerModules([AllCommunityModule, TooltipModule]);
    const endpoint = el.getAttribute('data-endpoint');
    if (!endpoint) {
        console.error('No endpoint specified for the sonata-variant-analysis-table widget');
        return;
    }
    const url = `${window.apiUri}${endpoint}`
    try {
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }
        const data = await response.json();
        
        const myTheme = themeQuartz.withParams({
            // wrapperBorder: false, 
        })

        const rowMaker = () => {
            let rows = data.sonatas.map(sonata => {
                let s = {}
                s.localindex = sonata.variations[0].local_index || null
                s.knum = sonata.name
                s.homekey = sonata.info[0].value ? sonata.info[0].value : 'N/A'
                // s.num_witness = sonata.num_witness
                s.data = sonata.gs_link || null
                return s
            })
            return rows
        }


        // Grid Options: Contains all of the Data Grid configurations
        const gridOptions = {
            theme: myTheme,
            domLayout: 'autoHeight',
            tooltipShowDelay: 0,
            tooltipHideDelay: 2000,
            pagination: true,
            paginationPageSize: 30,
            paginationPageSizeSelector: [10, 30, 50, 100],

            defaultColDef: {
                resizable: true,
            },

            autoSizeStrategy: {
                type: 'fitGridWidth',
                defaultMinWidth: 100,
            },

            
            // Column Definitions: Defines the columns to be displayed.
            columnDefs: [
                {
                    field: 'localindex',
                    headerName: 'Local Index',
                    sort: 'asc',
                    hide: true, //
                    valueGetter: params => {
                        // Return the numeric value for sorting
                        return parseInt(String(params.data.localindex));
                    }
                },
                
                { field: 'knum', pinned: 'left', headerName: 'K number', width: 220, cellStyle: { fontWeight: 'bold' }, 
                    sortable: true,
                    // sortingOrder: ["desc", "asc"],
                    valueGetter: params => {
                        // Return the numeric value for sorting
                        return parseInt(String(params.data.knum).replace(/^ks?/i, ''));
                    },
                    getQuickFilterText: params => {
                        // Return the original string for filtering
                        return params.data.knum;
                    },
                    cellRenderer: params => {
                    const originalValue = params.data.knum ;
                    return `
                    <div class="title-cell">
                        <a href="/sonata/${originalValue}" class="ag-btn">
                        ${originalValue}
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="6" fill="#EB131B"/>
                                <path d="M5 8.25L8 6.125L5 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                    `
                }},
                { field: 'homekey', headerName: 'Home Key', filter: true },
                // { field: 'num_witness', headerName: 'Number of Witnesses', filter: true },
                { field: 'data', headerName: 'Full Variant Analysis', filter: true, width: 280, cellRenderer: params => {
                    return params.value && `
                    <div class="link-cell">
                        <a href="${params.value}" class="ag-btn" target="_blank" rel="noopener noreferrer">
                            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.8329L2.87287 20.7063C3.09281 21.1008 3.40894 21.4107 3.78009 21.6361C4.84316 20.2532 5.58316 19.1921 6.00009 18.4526C6.42322 17.7022 6.94325 16.5284 7.56019 14.9312C5.89744 14.7069 4.63744 14.5947 3.78019 14.5947C2.95737 14.5947 1.69731 14.7069 0 14.9312C0 15.3678 0.109969 15.8044 0.329906 16.1989L1.81444 18.8329Z" fill="#0066DA"/>
                                <path d="M20.2199 21.6361C20.5912 21.4107 20.9073 21.1008 21.1271 20.7064L21.567 19.9317L23.6702 16.1989C23.8861 15.813 23.9998 15.376 24 14.9312C22.2928 14.7069 21.0351 14.5947 20.2269 14.5947C19.3582 14.5947 18.1004 14.7069 16.4536 14.9312C17.0632 16.5371 17.5764 17.7109 17.9932 18.4526C18.4134 19.2009 19.1557 20.262 20.2199 21.6361Z" fill="#EA4335"/>
                                <path d="M12.0003 7.04298C13.2303 5.52072 14.078 4.34691 14.5433 3.52154C14.918 2.85693 15.3304 1.79577 15.7804 0.33807C15.4092 0.11269 14.9832 0 14.5433 0H9.45734C9.01746 0 8.59146 0.126812 8.22021 0.33807C8.79271 2.00988 9.27846 3.19967 9.67746 3.90745C10.1185 4.68965 10.8927 5.73483 12.0003 7.04298Z" fill="#00832D"/>
                                <path d="M16.4401 14.9312H7.56027L3.78027 21.6361C4.15134 21.8614 4.57743 21.9741 5.0173 21.9741H18.9831C19.4229 21.9741 19.8491 21.8473 20.2202 21.636L16.4401 14.9312Z" fill="#2684FC"/>
                                <path d="M12.0001 7.04295L8.22009 0.338135C7.84884 0.563515 7.53272 0.87334 7.31278 1.2678L0.329906 13.6634C0.114024 14.0493 0.000298266 14.4863 0 14.9311H7.56019L12.0001 7.04295Z" fill="#00AC47"/>
                                <path d="M20.1788 7.46565L16.6872 1.2678C16.4674 0.87334 16.1512 0.563515 15.78 0.338135L12 7.04304L16.4398 14.9312H23.9863C23.9863 14.4945 23.8763 14.058 23.6564 13.6635L20.1788 7.46565Z" fill="#FFBA00"/>
                            </svg>
                            &nbsp;Download
                        </a>
                    </div>
                    `
                }},
            ],


            // Row Data: The data to be displayed.
            rowData: rowMaker(),

        };

        // Your Javascript code to create the Data Grid
        const myGridElement = document.querySelector('#ag-collection-sonata');
        const collectionSonatasTable = createGrid(myGridElement, gridOptions);
        const search = document.querySelector('#filter-text-box');
        
        const onFilterTextBoxChanged = () => {
            collectionSonatasTable.setGridOption("quickFilterText", search.value);
        }
        search.addEventListener('input', onFilterTextBoxChanged);
        loadingStates.forEach(container => container.classList.remove('loading'))


    } catch(error) {
        console.error(error.message)
    }
    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

